// extracted by mini-css-extract-plugin
export default {"body":"landingpage_body__wEcNV","header":"landingpage_header__hniRN","logo":"landingpage_logo__55EDs","parentBoxofLoader":"landingpage_parentBoxofLoader__XAdad"};